<template>
    <div class="content-container">
        <div class="heading-section my-4 col-md-8 offset-md-2 row align-items-center">
            <h1 class="text-left font-bold text-normal mt-3 col-md-5">
                OUR ESTATES
            </h1>
            <span class="d-block text-left col text-normal">
                will be equipped with state-of-the-art amenities like Recreation Centre, Supermarket, Park, Internet Service and much more.
            </span>
        </div>
        <div class="body-section col-12">
            <div class="row mx-0 justify-content-between" v-if="estateList"
                id="estates-content-container">
                <div class="card col-md-6 pb-4 estate-item-content"
                    v-for="estate in estateList" :key="estate.id">
                    <div class="card-content estate-item">
                        <div class="card-top-section">
                            <div class="overlay"></div>
                            <img :src="estate.main_photo" class="card-img-top" :alt="estate.title.rendered">
                            <div class="row mx-0 justify-content-center button-container"
                                v-if="estate.download_link">
                                <a :href="estate.download_link" 
                                target="_blank" rel="noopener noreferrer"
                                class="btn-default-style download-btn-estate">
                                    Make Reservation
                                </a>
                            </div>
                        </div>
                        <span class="item-title" v-html="estate.title.rendered"/>
                        <div class="card-body px-4" :class="{pb60: estate.video_url}">
                            <p class="card-text text-left text-normal mb-3" v-html="estate.content.rendered"></p>
                            <div class="row mt-2 mb-4">
                                <img :src="getImageUrl(estate.additional_photos, 1)" :alt="estate.title.rendered" class="col-md-6 mb-2 pr-md-2 img-fluid">
                                <img :src="getImageUrl(estate.additional_photos, 2)" :alt="estate.title.rendered" class="col-md-6 mb-2 pl-md-2 img-fluid">
                            </div>
                            <div class="row text-left text-normal add_features">
                                <div class="col item-list" v-if="estate.features_a">
                                    <span class="item d-block" v-for="(item, index) in estate.features_a.split('\n')"
                                        :key="index" v-html="item"></span>
                                </div>
                                <div class="col item-list" v-if="estate.features_b">
                                    <span class="item d-block" v-for="(item, index) in estate.features_b.split('\n')"
                                        :key="index" v-html="item"></span>
                                </div>
                                <div class="col item-list" v-if="estate.features_c">
                                    <span class="item d-block" v-for="(item, index) in estate.features_c.split('\n')"
                                        :key="index" v-html="item"></span>
                                </div>
                            </div>
                        </div>
                        <div class="row mx-0 justify-content-center py-3 video-container"
                            v-if="estate.video_url">
                            <button @click="showVideo(estate.video_url)" 
                            class="btn-default-style default-bg-color download-btn">
                                Watch Video
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row mx-0 justify-content-between" v-else>
                <Skeleton height="300px" />
            </div>
        </div>
        <b-modal id="home-modal" @hidden="modalHidden" size="lg" v-model="modalShow" centered>
            <youtube :video-id="videoId" ref="youtube"></youtube>
        </b-modal>
    </div>
</template>

<script>
import { Skeleton } from 'vue-loading-skeleton'

export default {
    name: 'Estates',
    components: {
        Skeleton
    },
    computed: {
        estateList() {
            return this.$store.state.estates
        },
    },
    created() {
        window.addEventListener('scroll', () => {
            this.bottom = this.bottom_visible()
        })
    },
    mounted() {
        this.bottom_visible();
    },
    watch: {
        bottom(bottom) {
            if (bottom) {
                this.add_estates();
            }
        },
        '$route'() {
            this.current_route = this.$route.path
        }
    },
    data() {
        return {
            bottom: false,
            videoId: '',
            modalShow: false,
        }
    },
    methods: {
        youtube_parser(url) {
            var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
            var match = url.match(regExp);
            return (match&&match[7].length==11)? match[7] : false;
        },
        showVideo(videoUrl) {
            this.videoId = this.youtube_parser(videoUrl)
            this.modalShow = true
        },
        getImageUrl(urlsString, index) {
            return urlsString.split("\n")[index - 1]
        },
        bottom_visible() {
            const el = document.getElementById('estates-content-container');
            const scrollY = window.scrollY;
            const topFromPageTop = el ? el.getBoundingClientRect().top : 0;
            const bottomFromPageTop = el ? el.getBoundingClientRect().bottom : 0;
            const heightFromTop = bottomFromPageTop - (topFromPageTop + scrollY + this.bottom ? 800 : 0);
            return heightFromTop < 0;
        },
        add_estates() {
            const currentPage = this.$store.state.currentEstatePage
            if (this.$store.state.getNewEstates) {
                return this.$store.dispatch('getEstates', currentPage + 1);
            }
        },
    },
}
</script>

<style scoped>
.pb60 {
    padding-bottom: 60px;
}
@media (min-width: 1200px) {
    .main-content {
        padding: 25px 60px;
    }
}
@media (min-width: 992px) {
    .main-content {
        padding: 20px 40px;
        border-radius: 20px;
        box-shadow: 10px 10px 6px #0000000D;
    }
}
@media (min-width: 768px) {
    .main-content {
        padding: 15px 30px;
    }
}
.card {
    border: none;
    background: transparent;
}
.card p, .card-text >>> p {
    margin-bottom: 5px;
}
.estate-item {
    border-radius: 15px;
    box-shadow: 5px 5px 6px #0000001A;
    border: 0.5px solid #D1D1D1;
    height: 100%;
    background: white;
    position: relative;
}
.item-title {
    font: Bold 20px/25px Segoe UI;
    letter-spacing: 1.2px;
    color: #FFFFFF;
    text-shadow: 0px 2px 6px #00000045;
    position: absolute;
    top: 15px;
    left: 30px;
    font-size: 13px;
}
.card-text {
    font-size: 12px;
    letter-spacing: 0.72px;
}
strong {
    font-size: 14px;
    display: block;
}
.img-content {
    margin-left: -2px;
    margin-top: -2px;
}
.overlay {
    border-radius: 7px;
    background-color: #6E216959;
    position: absolute;
    top: 0;
    left: 0;
    width: 97%;
    height: 98%;
}
.text-sm {
    font-size: 11px;
}
.body-section {
    margin: 30px 0 50px 0;
    padding: 0 2    0px
}
.download-btn,
.download-btn:hover,
.download-btn-estate,
.download-btn-estate:hover {
    padding-left: 30px;
    padding-right: 30px;
    text-transform: uppercase;
    display: inline-block;
    text-decoration: none;
    font-weight: 700!important;
}
.download-btn-estate,
.download-btn-estate:hover {
    border: transparent;
    color: #6E2169!important;
    background: #fff;
}
.download-btn,
.download-btn:hover {
    color: #fff;
    background: #6E2169;
}
.video-container {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
}
.text-description {
    color: #fff;
    position: absolute;
    width: 100%;
    top: 35%;
    text-align: center;
}
.add_features {
    font-size: 11px;
}
.card-top-section {
    width: 100%;
    position: relative;
    min-height: 150px;
}
.button-container {
    position: absolute;
    bottom: 60px;
    left: 0;
    width: 100%;
}
.estate-item-content {
    margin-bottom: 40px
}
@media (max-width: 768px) {
    .estate-item-content {
        margin-bottom: 20px
    }
    .button-container {
        bottom: 35px;
    }
    .add_features {
        font-size: 13px;
    }
    .item-list {
        flex: 0 0 100%;
        max-width: 100%;
        margin-top: 5px;
    }
}
.overlay {
    border-radius: 7px;
    background-color: #6E2169a2;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
}
</style>